import { type QueryClient } from '@tanstack/react-query';
import {
  GET_CUSTOMER_ORDERS_QUERY_KEY,
  GET_CUSTOMER_ORDERS_QUERY_KEY_CURRENT,
  GET_CUSTOMER_ORDERS_QUERY_KEY_PAST,
  GET_CUSTOMER_ORDERS_QUERY_KEY_UPCOMING,
} from './getOrderQueryKeys';
import { invalidateOrders } from './useGetOrder';
import { invalidateOrdersV3 } from './useGetOrdersV3';

export function invalidatePastCurrentUpcomingOrders(client: QueryClient) {
  client.invalidateQueries({ queryKey: GET_CUSTOMER_ORDERS_QUERY_KEY });
  client.invalidateQueries({
    queryKey: [GET_CUSTOMER_ORDERS_QUERY_KEY, { time_bucket: 'upcoming' }],
  });
  invalidateOrders(client);
  client.invalidateQueries({
    queryKey: [
      GET_CUSTOMER_ORDERS_QUERY_KEY,
      GET_CUSTOMER_ORDERS_QUERY_KEY_PAST,
    ],
  });
  client.invalidateQueries({
    queryKey: [
      GET_CUSTOMER_ORDERS_QUERY_KEY,
      GET_CUSTOMER_ORDERS_QUERY_KEY_CURRENT,
    ],
  });
  client.invalidateQueries({
    queryKey: [
      GET_CUSTOMER_ORDERS_QUERY_KEY,
      GET_CUSTOMER_ORDERS_QUERY_KEY_UPCOMING,
    ],
  });
  invalidateOrdersV3(client); // Invalidates every key that starts with ['Customer Orders', 'v3']
}
